module.exports = __webpack_public_path__ + "06adaf8fa055b90578bb66670acabb8b.jpg";